import script from "./ModalTermoConsentimento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTermoConsentimento.vue?vue&type=script&setup=true&lang=js"

import "./ModalTermoConsentimento.vue?vue&type=style&index=0&id=f7208966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7208966"]])

export default __exports__